<div class="row justify-content-around mt-4">
  <div class="col-5">
    <span class="first-last-loop-label">
      {{ 'first-shelve' | lang }}
    </span>
    <button class="btn-loop-detail" (click)="open('first-loop-modal-title', loop)"
      *ngFor="let loop of firstLoop">
      <span class="shift-char">
        {{ loop.shiftName }}
      </span>
      {{ loop.loopDatetime | withoutTimePresentation }} ({{ loop.loopQtyInPeriod }})
    </button>
  </div>
  <div class="col-5 text-right">
    <span class="first-last-loop-label">
      {{ 'last-shelve' | lang }}
    </span>
    <button class="btn-loop-detail" (click)="open('last-loop-modal-title', loop)"
      *ngFor="let loop of lastLoop">
      <span class="shift-char">
        {{ loop.shiftName }}
      </span>
      {{ loop.loopDatetime | withoutTimePresentation }} ({{ loop.loopQtyInPeriod }})
    </button>
  </div>
</div>
